import './index.scss'
import image1 from '../../assets/images/siemensworld_home.jpg'


const Work = () => {
    return (
        <>
             <div className = "container project-page">
                <div className="text-zone">
                    <h1>Recent Projects</h1>
                    <p>Siemens World Blog, an internal site for siemens employees.</p>

                </div>
                <div className = "project">
                <img className = "Project_img" src={image1} alt="sw_home" />;
                </div>
            </div>
        </>
    )
}    

export default Work